<template>
  <div class="auth-page">
    <div class="auth-card">
      <h1>Вход</h1>
      <form @submit.prevent="submit">
        <div class="form-field">
          <label for="email">Email</label>
          <input id="email" v-model="email" type="email" autocomplete="email" required />
        </div>
        <div class="form-field">
          <label for="password">Пароль</label>
          <input id="password" v-model="password" type="password" autocomplete="current-password" required />
        </div>
        <p v-if="error" class="error-message">{{ error }}</p>
        <p v-if="unconfirmedEmail" class="error-message">
          Подтвердите email.
          <router-link :to="{ name: 'check-email', query: { email: unconfirmedEmail } }">
            Отправить письмо повторно
          </router-link>
        </p>
        <button class="btn" type="submit" :disabled="loading">
          {{ loading ? 'Вход...' : 'Войти' }}
        </button>
      </form>
      <p style="margin-top: 1rem">
        <router-link to="/forgot-password">Забыли пароль?</router-link>
      </p>
      <p style="margin-top: 0.5rem">
        Нет аккаунта?
        <router-link to="/register">Зарегистрироваться</router-link>
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '../stores/auth'

const auth = useAuthStore()
const router = useRouter()
const route = useRoute()

const email = ref('')
const password = ref('')
const loading = ref(false)
const error = ref('')
const unconfirmedEmail = ref('')

async function submit() {
  loading.value = true
  error.value = ''
  unconfirmedEmail.value = ''

  try {
    await auth.login(email.value, password.value)
    router.push(route.query.redirect || '/')
  } catch (err) {
    const message = err.response?.data?.error || 'Неверный email или пароль'
    error.value = message
    if (message.includes('Подтвердите email')) {
      unconfirmedEmail.value = email.value
      error.value = ''
    }
  } finally {
    loading.value = false
  }
}
</script>
